module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-upload"
  }, [(_vm.isInitial || _vm.isSaving) ? _c('form', {
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "file-input-container",
    class: {
      'uploading': _vm.isSaving
    }
  }, [_c('input', {
    staticClass: "file-input",
    attrs: {
      "id": "file-input",
      "type": "file",
      "multiple": "",
      "name": _vm.uploadFieldName,
      "disabled": _vm.isSaving
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.name, $event.target.files);
        _vm.fileCount = $event.target.files.length
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "file-input"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "17",
      "viewBox": "0 0 20 17"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Choose a file…")])]), _vm._v(" "), (_vm.isSaving) ? _c('p', {
    staticClass: "file-upload-loader"
  }, [_c('loading-screen', {
    attrs: {
      "show": true,
      "color": '#3598dc',
      "display": 'inline',
      "position": 'left',
      "size": 'small'
    }
  }), _vm._v("\n\t\t\t\tUploading " + _vm._s(_vm.fileCount) + " file" + _vm._s(_vm.fileCount > 1 ? 's' : '') + "...\n\t\t\t")], 1) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27a6c728!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Resources/FileUpload.vue
// module id = 414
// module chunks = 1